module.exports = __webpack_public_path__ + "img/Georgia.57d4c596.jpg";